import { AllocationRule } from 'further-types/lp/allocations';
import {
  CapitalActionEntryType,
  DrawdownSourcePriority,
} from 'further-types/lp/capital-action';

const defaultEntryValues = {
  [CapitalActionEntryType.Expense]: {
    entryType: CapitalActionEntryType.Expense,
    drawdownSourcePriority: DrawdownSourcePriority.UnallocatedCommitmentFirst,
    actions: [],
    totalAmountLcy: 0,
    capitalBreakdown: [],
  },
  [CapitalActionEntryType.Investment]: {
    entryType: CapitalActionEntryType.Investment,
    drawdownSourcePriority: DrawdownSourcePriority.UnallocatedCommitmentFirst,
    actions: [],
    totalAmountLcy: 0,
    capitalBreakdown: [],
  },
  [CapitalActionEntryType.Fees]: {
    entryType: CapitalActionEntryType.Fees,
    actions: [],
    totalAmountLcy: 0,
    capitalBreakdown: [],
  },
  [CapitalActionEntryType.CapitalRefund]: {
    entryType: CapitalActionEntryType.CapitalRefund,
    actions: [],
    totalAmountLcy: 0,
    capitalBreakdown: [],
  },
  [CapitalActionEntryType.CapitalContributionCall]: {
    entryType: CapitalActionEntryType.CapitalContributionCall,
    actions: [],
    totalAmountLcy: 0,
    capitalBreakdown: [],
  },
  [CapitalActionEntryType.GeneralCapitalCall]: {
    entryType: CapitalActionEntryType.GeneralCapitalCall,
    allocationRule: AllocationRule.ByCommitmentAndClosingDate,
    drawdownSourcePriority: DrawdownSourcePriority.UnallocatedCommitmentFirst,
    actions: [],
    totalAmountLcy: 0,
    capitalBreakdown: [],
  },
  [CapitalActionEntryType.AdvanceSubscriptionPayment]: {
    entryType: CapitalActionEntryType.AdvanceSubscriptionPayment,
    drawdownSourcePriority: DrawdownSourcePriority.UnallocatedCommitmentFirst,
    actions: [],
    totalAmountLcy: 0,
    capitalBreakdown: [],
  },
  [CapitalActionEntryType.CapitalDistribution]: {
    entryType: CapitalActionEntryType.CapitalDistribution,
    actions: [],
    totalAmountLcy: 0,
    capitalBreakdown: [],
  },
  [CapitalActionEntryType.Equalisation]: {
    entryType: CapitalActionEntryType.Equalisation,
    actions: [],
    totalAmountLcy: 0,
    capitalBreakdown: [],
  },
  [CapitalActionEntryType.PartnerTransfer]: {
    entryType: CapitalActionEntryType.PartnerTransfer,
    actions: [],
    totalAmountLcy: 0,
    capitalBreakdown: [],
  },
};

export default function useDefaultEntryValues({
  capitalContributionIsDefault = false,
  equalisationIsDefault = false,
  partnerTransferIsDefault = false,
}: {
  capitalContributionIsDefault?: boolean;
  equalisationIsDefault?: boolean;
  partnerTransferIsDefault?: boolean;
} = {}) {
  return {
    defaultEntryValues,
    defaultEntry: equalisationIsDefault
      ? defaultEntryValues[CapitalActionEntryType.Equalisation]
      : partnerTransferIsDefault
      ? defaultEntryValues[CapitalActionEntryType.PartnerTransfer]
      : capitalContributionIsDefault
      ? defaultEntryValues[CapitalActionEntryType.CapitalContributionCall]
      : defaultEntryValues[CapitalActionEntryType.Expense],
  };
}
